<template>
  <div class="remote_monitor_area no-drag">
    <video
        id="yourVideo"
        :class="meetingStatusProps === 'on'? '' : 'hidden'"
        ref="yourVideo"
        style="height: 100%; width: 100%;"
    />
    <MeetingStatus
        :meetingStatusProps="meetingStatusProps"
        :progressTimeProps="progressTimeProps"
    />
  </div>
</template>
<script>
import MeetingStatus from './meetingStatus';

  export default {
    name : 'monitorArea',
    props : ['meetingStatusProps', 'progressTimeProps'],
    components :{MeetingStatus},
    data() {
      return {
        reverse: true,
      }
    },
    methods: {
      handleVideoClick() {
        this.reverse = !this.reverse
      }
    }
  }
</script>